import { render, staticRenderFns } from "./MainBar.vue?vue&type=template&id=1430cf56&scoped=true&"
import script from "./MainBar.vue?vue&type=script&lang=js&"
export * from "./MainBar.vue?vue&type=script&lang=js&"
import style0 from "./MainBar.vue?vue&type=style&index=0&id=1430cf56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1430cf56",
  null
  
)

export default component.exports